import apiClient from './client'
import { User, TaskStats } from '../types'

export interface RegisterUserRequest {
  telegram_id: number
  username?: string
  first_name?: string
  last_name?: string
  language_code?: string
}

export const usersApi = {
  // Register new user
  registerUser: async (data: RegisterUserRequest): Promise<User> => {
    const response = await apiClient.post('/api/v1/users/register', data)
    return response.data
  },

  // Get user by Telegram ID
  getUserByTelegramId: async (telegramId: number): Promise<User> => {
    const response = await apiClient.get(`/api/v1/users/telegram/${telegramId}`)
    return response.data
  },

  // Get user by UUID
  getUserById: async (userId: string): Promise<User> => {
    const response = await apiClient.get(`/api/v1/users/${userId}`)
    return response.data
  },

  // Get user task statistics
  getUserTaskStats: async (telegramUserId: number): Promise<TaskStats> => {
    const response = await apiClient.get(`/api/v1/users/tasks/telegram/${telegramUserId}/stats`)
    return response.data
  },

  // Get user balance
  getUserBalance: async (userId: string): Promise<{ user_id: string; balance: number }> => {
    const response = await apiClient.get(`/api/v1/users/balance/${userId}`)
    return response.data
  },

  // Update user profile
  updateUserProfile: async (
    userId: string,
    data: Partial<Pick<User, 'username' | 'first_name' | 'last_name'>>
  ): Promise<User> => {
    const response = await apiClient.put(`/api/v1/users/profile/${userId}`, data)
    return response.data
  },
}
